import { useNavigate } from "react-router-dom";

const SERVER = (import.meta.env.VITE_URL_SERVER as string | undefined)?.replace(/\/$/, "") ?? "";

export default function SigninPage() {
  const navigate = useNavigate();

  const redirectToSso = () => {
    const callback = `${window.location.origin}/callback`;
    window.location.href = `${SERVER}/api/login/token?url_redirect=${encodeURIComponent(callback)}`;
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "var(--sp-6)",
        background: "var(--paper)",
        position: "relative",
        zIndex: 1,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 480,
          background: "var(--paper-warm)",
          border: "1px solid var(--line)",
          borderRadius: "var(--radius-l)",
          boxShadow: "var(--shadow-l)",
          padding: "var(--sp-8)",
          position: "relative",
        }}
      >
        <button
          type="button"
          onClick={() => navigate("/")}
          style={{
            background: "none",
            border: "none",
            color: "var(--ink-mute)",
            fontSize: 13,
            cursor: "pointer",
            padding: 0,
            marginBottom: "var(--sp-6)",
            fontFamily: "var(--font-body)",
          }}
        >
          ← Retour à l'accueil
        </button>

        <div style={{ textAlign: "center", marginBottom: "var(--sp-7)" }}>
          <div
            style={{
              fontFamily: "var(--font-script)",
              color: "var(--pink)",
              fontSize: 22,
              transform: "rotate(-3deg)",
              marginBottom: "var(--sp-2)",
            }}
          >
            Bonjour !
          </div>
          <h1
            style={{
              fontFamily: "var(--font-display)",
              fontSize: 40,
              lineHeight: 1.05,
              margin: 0,
              color: "var(--ink)",
              textTransform: "uppercase",
              letterSpacing: "-0.01em",
            }}
          >
            Connexion
          </h1>
          <p
            style={{
              color: "var(--ink-mute)",
              fontSize: 14,
              marginTop: "var(--sp-3)",
              marginBottom: 0,
            }}
          >
            Connectez-vous pour accéder à votre espace d'administration.
          </p>
        </div>

        <button onClick={redirectToSso} className="btn btn-primary" style={{ width: "100%", padding: "14px 18px" }}>
          Se connecter
        </button>
      </div>
    </div>
  );
}
